import { Box, Paper, styled, Typography } from '@mui/material';
import { palette } from '../../theme';

export const StyledStepWrapper = styled('div')(() => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
}));

export const StyledTextWrapper = styled('div')(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: '10px',
}));

export const StyledInputWrapper = styled('div')(() => ({
  width: '60%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledButtonsWrapper = styled('div')(() => ({
  marginTop: 20,
  width: '50%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledProfileSection = styled(Box)(() => ({
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  marginBottom: 24,
}));

export const StyledSectionHeader = styled(Typography)(() => ({
  color: palette.primary.main,
  fontWeight: 600,
  marginBottom: 4,
}));

export const StyledSectionDescription = styled(Typography)(() => ({
  color: palette.text.main,
  display: 'block',
  marginTop: 4,
  marginBottom: 16,
}));

export const StyledSectionContent = styled(Paper)(() => ({
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
  boxSizing: 'border-box',
  overflowX: 'hidden',
  padding: 16,
  borderRadius: 12,
  backgroundColor: '#fff',
  boxShadow: 'none',
  border: `1px solid ${palette.divider}`,
}));

export const StyledAccountActions = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: 8,
  paddingTop: 12,
}));

type StyledChannelCardProps = {
  selected?: boolean;
  disabled?: boolean;
};

export const StyledChannelCard = styled(Paper, {
  shouldForwardProp: (prop) => prop !== 'selected' && prop !== 'disabled',
})<StyledChannelCardProps>(({ selected, disabled }) => ({
  width: '100%',
  height: '100%',
  minHeight: 148,
  padding: 16,
  borderRadius: 12,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: 8,
  boxSizing: 'border-box',
  cursor: disabled ? 'not-allowed' : 'pointer',
  opacity: disabled ? 0.6 : 1,
  border: `2px solid ${selected ? palette.secondary.main : palette.divider}`,
  backgroundColor: selected ? 'rgba(255, 115, 0, 0.08)' : '#fff',
  boxShadow: 'none',
  transition: 'border-color 0.2s ease, background-color 0.2s ease',
  '&:hover': {
    borderColor: disabled
      ? palette.divider
      : selected
      ? palette.secondary.main
      : palette.primary.main,
  },
}));

export const StyledChannelHint = styled(Typography)(() => ({
  color: palette.text.main,
  fontSize: 12,
  textAlign: 'center',
  display: 'block',
  marginTop: 16,
}));
